export var ContextGLTextureFilter;
(function (ContextGLTextureFilter) {
    ContextGLTextureFilter[ContextGLTextureFilter["LINEAR"] = 0] = "LINEAR";
    ContextGLTextureFilter[ContextGLTextureFilter["NEAREST"] = 1] = "NEAREST";
})(ContextGLTextureFilter || (ContextGLTextureFilter = {}));
